<!--
Usage:
<dropdown title="New Edit1" :link="{name: 'description', params: {id: 'all'}}">
    <li><a href="/programs/all/edit/description">Edit</a></li>
    <li><a href="/programs/all/registrations">Registrations</a></li>
</dropdown>
-->

<template>
    <div class="main">
        <span class="dropdown-buttons" ref="main" v-if="link">
            <router-link :to="link" class="button primary-action">{{title}}</router-link><a href="#" ref="down" class="button dropdown dropdown-trigger secondary" @click.prevent="open=!open" @keydown.enter.prevent="open=!open" @keydown.space.prevent="open=!open" @keydown.esc="closeDropdown" aria-haspopup="true" :aria-expanded="open.toString()"></a>
        </span>

        <span ref="main" v-else-if="single_button" >
            <a href="#" class="button success" @click.prevent="open=!open" @keydown.enter.prevent="open=!open" @keydown.space.prevent="open=!open" @keydown.esc="closeDropdown" ref="down" aria-haspopup="true" :aria-expanded="open.toString()">{{title}}</a>
        </span>

        <span class="dropdown-buttons" ref="main" v-else-if="open_on_main_click">
            <a href="#" class="button primary-action" @click.prevent="open=!open" @keydown.enter.prevent="open=!open" @keydown.space.prevent="open=!open" @keydown.esc="closeDropdown" ref="primary" aria-haspopup="true" :aria-expanded="open.toString()">{{title}}</a><a href="#" ref="down" class="button dropdown dropdown-trigger secondary" @click.prevent="open=!open" @keydown.enter.prevent="open=!open" @keydown.space.prevent="open=!open" @keydown.esc="closeDropdown"></a>
        </span>

        <span class="dropdown-buttons" ref="main" v-else>
            <a class="button primary-action" @click="$emit('main-click')" :class="{'student_transfer_disabled': student_transfer_org_disabled}">{{title}}</a><a href="#" ref="down" class="button dropdown dropdown-trigger secondary" :class="{'student_transfer_disabled': student_transfer_org_disabled}" @click.prevent="open=!open" @keydown.enter.prevent="open=!open" @keydown.space.prevent="open=!open" @keydown.esc="closeDropdown" aria-haspopup="true" :aria-expanded="open.toString()"></a>
        </span>
        <ul ref="menu" class="f-dropdown" :class="[{hidden: !open}, text_align]" :style="{top:top + 'px',left:left+'px'}" role="menu" @keydown="handleMenuKeydown">
            <slot />
        </ul>
    </div>
</template>
<script>
export default{
  props: {
    title: String,
    link: [String, Object],
    single_button: {
      type: Boolean,
      default: false
    },
    text_align: {
      type: String,
      default: 'right',
    },
    open_on_main_click: {
      type: Boolean,
      default: false
    },
    student_transfer_org_disabled: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      open: false,
      left: 0,
      top: 0
    }
  },
  watch: {
    open(){ 
      this.setPosition()
      // When dropdown opens, move focus to first item
      if (this.open) {
        this.$nextTick(() => {
          const items = this.$refs.menu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])')
          if (items.length > 0) {
            items[0].focus()
          }
        })
      }
    }
  },
  mounted(){
    window.addEventListener("click", this.close)
    window.addEventListener("scroll", this.setPosition)
    window.addEventListener("resize", this.setPosition)

    this._scroll = this.$el.closest("[data-doublescroll]")
    if (this._scroll) this._scroll.addEventListener("scroll", this.setPosition)
  },
  destroyed() {
    window.removeEventListener("click", this.close)
    window.removeEventListener("scroll", this.setPosition)
    window.removeEventListener("resize", this.setPosition)

    if (this._scroll) this._scroll.removeEventListener("scroll", this.setPosition)
  },
  methods:{
    close(e){
      if (e.target === this.$refs.down || e.target === this.$refs.primary) return;
      if (!this.open) return;
      this.open = false
    },
    closeDropdown() {
      this.open = false
      const trigger = this.$refs.down || this.$refs.primary
      if (trigger) this.$nextTick(() => trigger.focus())
    },
    handleMenuKeydown(e) {
      const items = Array.from(this.$refs.menu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])'))
      const idx = items.indexOf(document.activeElement)
      
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault()
          if (!this.open) {
            this.open = true
          } else {
            items[(idx + 1) % items.length]?.focus()
          }
          break
        case 'ArrowUp':
          e.preventDefault()
          if (!this.open) {
            this.open = true
          } else {
            items[(idx - 1 + items.length) % items.length]?.focus()
          }
          break
        case 'Escape':
          e.preventDefault()
          this.closeDropdown()
          break
        case 'Tab':
          // Allow Tab to work normally - move to next item or close if at the end
          if (idx >= 0 && idx < items.length - 1) {
            e.preventDefault()
            items[idx + 1]?.focus()
          } else {
            // Last item or not in menu - allow Tab to close and move to next page element
            this.open = false
          }
          break
      }
    },
    setPosition(){
      if (this.open){
        this.left = this.$refs.main.getBoundingClientRect().left - 20
        this.top = this.$refs.main.getBoundingClientRect().top + this.$refs.main.clientHeight
      }
    },
  }
}
</script>
<style scoped>
  .dropdown-trigger{
    min-width: 0 !important;
  }
  .f-dropdown{
      position: fixed;
      /*top:auto;*/
  }
  .main{
      /*position: relative;*/
      display: inline-block;
  }
  /*.success{*/
  /*  background-color: #476da7;*/
  /*  border: 0 !important;*/
  /*  border-radius: 4px !important;*/
  /*  box-shadow: 0 2px 8px #476da7;*/
  /*  color: #fff;*/
  /*  cursor: pointer;*/
  /*  font-size: 0.9rem;*/
  /*  font-weight: 600;*/
  /*  overflow-wrap: break-word;*/
  /*  padding: 0.6rem 0.8rem;*/
  /*  min-height: 32px;*/
  /*  text-align: center;*/
  /*}*/
  .button{
    height: 36px !important;
    margin-bottom: 0;
  }
  .student_transfer_disabled{
    background-color: #f3f3f3!important;
    color: #71727a!important;
    border: 1px solid #919397!important;
    pointer-events: none;
  }
  .icon-margin{
    margin-top: 12px;
  }
</style>
